import { gatewayClient, createService } from './connectors/httpClient';
import { gatewayStream } from './connectors/sseClient';

const httpClient = gatewayClient('/creatives');
// The thumbnails stream lives under a different prefix; that is an implementation detail here.
const thumbnailsStream = gatewayStream('/presentation-media');

const designsService = createService(httpClient, (client) => ({
    createBlankDesign(data, collectionId) {
        let path = `/blank`;

        if (collectionId) {
            path += `?collectionId=${collectionId}`;
        }

        return client.put<{ id: number; name: string }>(path, data);
    },

    createFromXML(data, collectionId) {
        return client.post(`/from-xml${collectionId ? `?collectionId=${collectionId}` : ''}`, data);
    },

    duplicateCreatives(ids, collectionId) {
        return client.put('/duplicate', { ids, collectionId });
    },

    createVideoCreative(data) {
        return client.put<{ id: number }>('/convert', data);
    },
}));

export type DesignThumbnailStatus = 'PROCESSING' | 'PROCESSED' | 'FAILED' | 'UNKNOWN' | 'NOT_FOUND';

export type DesignThumbnailItem = {
    creativeId: number;
    thumbnailUrl: string | null;
    thumbnailStatus: DesignThumbnailStatus;
};

// No unsubscribe from inside onMessage: the stream ends itself once every thumbnail is terminal.
export function listenToDesignThumbnails(
    creativeIds: number[],
    onItems: (items: DesignThumbnailItem[]) => void,
    onClose?: () => void,
): () => void {
    return thumbnailsStream.subscribe<{ totalItems: number; items: DesignThumbnailItem[] }, { creativeIds: number[] }>(
        '/list-creatives/stream',
        {
            eventName: 'progress',
            body: { creativeIds },
            onMessage: ({ items }) => onItems(items),
            onClose,
        },
    );
}

export default designsService;
